














































































// TODO: Enable lint.
/* eslint-disable */
import { computed, defineComponent, onMounted, reactive, ref, SetupContext } from '@vue/composition-api';
import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';
import axios from 'axios';
import { v4 as uuidv4 }from 'uuid';
import html2canvas from 'html2canvas';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

type Template = {
  id: string,
  name: string,
  created_at: string,
  updated_at: string,
  organization_id: string,
  is_vertical: boolean,
  has_description: boolean,
  has_image: boolean,
  has_spec: boolean,
};

type Project = {
  id: string,	
	organization_id: string,
	user_id: string,       
	name: string,         
	supplemental_memo: string,
	internal_memo: string,
  default_cp_template_id: string,
	is_archived: boolean,
	created_at: string,    
	updated_at: string,  
};

type Concept = {
	id: string,
	project_id: string,
	cp_template_id: string,
	name?: string,
	title?: string,
	description?: string,
	concept_image_id?: string,
	image_vertical_size?: number,
	topbox?: number,
	sum_of_top2box?: number,
  spec_style: string,
	created_at: string,
	updated_at: string,

  project_name: string 
};

type Spec = {
	id: string,
	concept_id: string,
	name: string,
	content: string,
	created_at: string,
	updated_at: string,
  name_placeholder: string,
  content_placeholder: string,
};

type Props = {
  id: string;
};

export default defineComponent({
  name: "ConceptGenerator",
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    NavHeader,
    Footer
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: '/css/login/project.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "/js/toggle_contents.js" },
      { src: "/js/project.js" },
    ]
  },

  setup(props: Props, context: SetupContext) {
    const state = reactive({
      paretto: 'default',
      projectName: '',
      beingDeletedSpecID: '',
      concept: {} as Concept,
      conceptImageData: '',
      specs: [
        { id: uuidv4(), name: '', content: '', name_placeholder: '価格', content_placeholder: '330円（税込み）' },
        { id: uuidv4(), name: '', content: '', name_placeholder: '売り場', content_placeholder: 'コンビニエンスストア' },
        { id: uuidv4(), name: '', content: '', name_placeholder: '味', content_placeholder: '○○○○○○○○○○○○○○○風味' }
      ] as Spec[],
      generatedImageData: '',
      confirming: false,
    });

    const cpcard = ref<HTMLDivElement>(null);
    const conceptImage = ref<HTMLImageElement>(null);

    const specRecords = computed(() => {
      if (state.concept.spec_style === 'single-column') {
        return state.specs.map(s => {
          return [s];
        });
      } else {
        return state.specs.reduce(
          (ss, _, i) => (i % 2 ? ss : [...ss, state.specs.slice(i, i + 2)]),
          [] as Spec[][]
        );
      }
    });

    async function load() {
      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        queryStringParameters: {  // OPTIONAL
          pid: '',
          cid: ''
        }
      }

      API.get('dev', '/concepts/' + props.id, options).then(response => {
        console.log(response);
        state.concept = response.data.concept;
        state.concept.title = state.concept.title || '';
        state.concept.description = state.concept.description || '';
        state.specs = response.data.specs;
        state.projectName = state.concept.project_name;

        options.queryStringParameters.pid = state.concept.project_id;
        options.queryStringParameters.cid = state.concept.id;

        API.get('dev', '/images/cpimages/' + state.concept.concept_image_id, options).then(response => {
          state.conceptImageData = response.data.url
          axios.get(response.data.url, { responseType: 'blob' }).then(response => {
            console.log(response.data);
            const reader = new FileReader();
            reader.onload = (e: Event) => {
              state.conceptImageData = reader.result as string
            };
            reader.readAsDataURL(response.data);
          });
        }).catch(err => {
          console.log(err);
        });

        console.log(state);
      }).catch(err => {
        console.log(err);
      });
    }
    load();

    async function updateConcept() {
      console.log(state);

      const options = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
        },
        body: state.concept
      }

      API.put('dev', '/concepts', options).then(response => {
        console.log(response);
        context.root.$router.push({ name: 'ConceptEdit', params: { id: response.data.id } });
      }).catch(err => {
        console.log(err);
      });
    }

    function changeParetto(name: string, event: Event) {
      state.paretto = name;
    }

    function selectFile(e: Event) {
      const target = e.target as HTMLInputElement
      const files = target.files as FileList

      if (files.length > 0) {
        previewImage(files[0])
      }
    }

    function previewImage(file: File) {
      const reader = new FileReader();
      reader.onload = (e: Event) => {
        state.conceptImageData = reader.result as string
      };
      reader.readAsDataURL(file);
    }

    function addSpec() {
      state.specs.push({ id: uuidv4() } as Spec);
    }

    function deleteSpec(id: string) {
      state.specs = state.specs.filter((spec) => spec.id !== id);
    }

    function confirmCard() {
      state.confirming = true;
    }

    function returnToEditor() {
      state.confirming = false;
    }

    async function generateCardImage() {
      console.log('Generating an image...');
      console.log(cpcard.value);

      const options = {
        baseURL: `${(await API.endpoint('dev'))}`,
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
        }
      };
    
      html2canvas(cpcard.value!, {
        scale: 1.,
        backgroundColor: null,
        scrollX: -window.scrollX,
        scrollY: -window.scrollY-0.5, // NOTE: Hack the html2canvas's border related bug...
      }).then(canvas => {
        state.generatedImageData = canvas.toDataURL('image/jpeg');

        const mediaType = 'image/jpeg';

        canvas.toBlob((blob) => {
          const api = axios.create(options);
          const data = new FormData();

          data.append('name', state.concept.name + '.' + mediaType.replace('image/', ''));
          data.append('image', blob!);
          data.append('pid', state.concept.project_id);
          data.append('cid', state.concept.id);

          api.post('/images/cpcards', data).then(response => {
            console.log(response);
            context.root.$router.push({ name: 'ConceptDetail', params: { id: state.concept.id } });
          }).catch(err => {
            console.log(err);
          });
        }, mediaType);
      });
    };

    return {
      state,

      specRecords,

      cpcard,
      conceptImage,

      updateConcept,
      changeParetto,
      confirmCard,
      returnToEditor,
      generateCardImage,
      selectFile,
      addSpec,
      deleteSpec,
    };
  }
});
